import { ChangeDetectionStrategy, Component, DestroyRef, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatMenu, MatMenuContent, MatMenuTrigger } from '@angular/material/menu';
import { Router, RouterLink } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { CourseStoreModel, SyllabusQuery } from '@examdojo/category';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { NgClass } from '@angular/common';
import { IonButton } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { EMPTY } from 'rxjs';
import { RootUrlParts } from '../../../../../app.model';
import { SettingsUrlParts } from '../../../../../settings/settings.model';
import { CourseManagementService } from '../../../../course-management/course-management.service';

@Component({
  selector: 'dojo-course-select-menu',
  imports: [
    IonButton,
    MatMenu,
    MatMenuContent,
    MatMenuTrigger,
    IconComponent,
    TranslocoPipe,
    ButtonComponent,
    RouterLink,
    NgClass,
  ],
  templateUrl: './course-select-menu.component.html',
  styleUrls: ['./course-select-menu.component.scss', '../../sidebar-top-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'min-w-0 overflow-hidden' },
})
export class CourseSelectMenuComponent {
  constructor(
    private readonly syllabusQuery: SyllabusQuery,
    private readonly courseManagementService: CourseManagementService,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly destroyRef: DestroyRef,
    private readonly router: Router,
  ) {}

  private readonly menuTrigger = viewChild.required<MatMenuTrigger>('menuTrigger');

  readonly state = connectState({
    activeSyllabus: this.syllabusQuery.active$,
    activeCourse: this.courseManagementService.activeCourse$,
    courses: this.courseManagementService.subscribedCourses$,
  });

  protected navigateToCoursesSettings(): void {
    this.router.navigate([RootUrlParts.Settings, SettingsUrlParts.Courses]);
  }

  onCourseSelected(course: CourseStoreModel): void {
    this.menuTrigger().closeMenu();
    this.courseManagementService
      .updateSelectedCourse({
        syllabusId: course.syllabus_id,
        courseLevel: course.course_level,
      })
      .pipe(
        this.errorHandlerService.catchHttpErrors(() => EMPTY),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
